import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

export default Component((node) => {
  const HIDDEN_CLASS = 'header--hidden';
  const heightThreshold = node.offsetHeight;
  let isBelowHeader = window.scrollY > heightThreshold;
  let lastScrollPosition = window.scrollY;
  let scrollingDown = false;

  let write: () => void;
  let read: () => void;

  const scrollEvent = () => {
    if (write) fastdom.clear(write);
    if (read) fastdom.clear(read);

    read = fastdom.measure(() => {
      isBelowHeader = window.scrollY > heightThreshold;
      scrollingDown = window.scrollY > lastScrollPosition;
    })

    write = fastdom.mutate(() => {
      if (isBelowHeader) {
        node.classList.add('header--scrolled');
      } else {
        node.classList.remove('header--scrolled');
      }

      if (scrollingDown && isBelowHeader) {
        node.classList.add(HIDDEN_CLASS);
        document.documentElement.style.setProperty('--header-offset', '0')
      } else {
        node.classList.remove(HIDDEN_CLASS);
        document.documentElement.style.setProperty('--header-offset', `${heightThreshold}px`)
      }


      lastScrollPosition = window.scrollY;
    });
  };

  window.addEventListener('scroll', scrollEvent, {
    passive: true,
  });
});
